// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layer-wise latency breakdown table + its VIN popover: extends the Device Bucketing
   table styles (FrequencyBucketTable.module.css). */

/* =========================================
   COLUMNS
========================================= */

/* the wrapper scrolls on small screens */
table.LayerLatencyTable_table__1Rl-g {
    min-width: 820px;
}

/* table */
.LayerLatencyTable_colLocation__Cp0fF {
    width: 22%;
}

.LayerLatencyTable_colActive__LBSMk {
    width: 9%;
}

.LayerLatencyTable_colPct__5TL\\+o {
    width: 9%;
}

.LayerLatencyTable_colBucket__7x2gw {
    width: 10%;
}

.LayerLatencyTable_colOverall__pZH-X {
    width: 11%;
}

/* VIN popover */
.LayerLatencyTable_colVin__73\\+nc {
    width: 18%;
}

.LayerLatencyTable_colReg__oEqNS {
    width: 12%;
}

/* =========================================
   TWO-ROW HEADER
========================================= */

.LayerLatencyTable_groupHeader__AH0y3 {
    height: 22px !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.45) !important;
}

/* second header row sticks right below the group header */
.LayerLatencyTable_subHeader__tdjN3 {
    top: 23px !important;
    height: 24px !important;
}

.LayerLatencyTable_headerHint__f7C6p {
    display: block;
    font-size: 9px;
    font-weight: 600;
    opacity: 0.85;
}

/* =========================================
   VIN STATUS (popover)
========================================= */

.LayerLatencyTable_activeTag__RjBv8 {
    display: inline-block;
    padding: 1px 7px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 600;
}

.LayerLatencyTable_activeOn__M0Tnt {
    background-color: #eafaf0;
    color: #1aa054;
}

.LayerLatencyTable_activeOff__EaMdZ {
    background-color: #f1f3f5;
    color: #8a97a3;
}

/* =========================================
   NOTES (table footer, sticks to the bottom like the header)
========================================= */

.LayerLatencyTable_notesFoot__jz94n td {
    position: sticky;
    bottom: 0;
    z-index: 2;

    padding: 5px 10px;
    background-color: #f4f6f8;
    border-top: 1px solid #dee2e6;

    font-size: 10.5px;
    color: #6b7785;
    text-align: left;
    white-space: normal;
}

.LayerLatencyTable_notesFoot__jz94n span {
    display: inline-block;
    margin-right: 24px;
}

.LayerLatencyTable_notesFoot__jz94n strong {
    color: #3a4651;
    font-weight: 600;
}

/* =========================================
   TONES (buckets + %), city, depot and VIN rows.
   Scoped to .table td so they beat the grey \`.depotRow td\` colour.
========================================= */

.LayerLatencyTable_table__1Rl-g td.LayerLatencyTable_tone_green__hSHw\\+ {
    color: #1aa054;
}

.LayerLatencyTable_table__1Rl-g td.LayerLatencyTable_tone_yellow__mrldN {
    color: #e6b800;
}

.LayerLatencyTable_table__1Rl-g td.LayerLatencyTable_tone_amber__kKTmH {
    color: #f59e0b;
}

.LayerLatencyTable_table__1Rl-g td.LayerLatencyTable_tone_red__NYj\\+b {
    color: #e5384d;
}

.LayerLatencyTable_table__1Rl-g td.LayerLatencyTable_tone_grey__ieAQG {
    color: #aeb8c1;
    font-weight: 400;
}
.LayerLatencyTable_ignition__dX0IJ {
  --track-off: #dbe3f1;
  --track-on: #5b86d6;
  --knob: #ffffff;
  --label: #2b3a55;
  --state: #5b7bb5;

  display: inline-flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
}

.LayerLatencyTable_label__43aIR {
  font-size: 18px;
  font-weight: 600;
  color: var(--label);
}

.LayerLatencyTable_switch__8feyM {
  position: relative;
  width: 52px;
  height: 26px;
  flex: none;
}

.LayerLatencyTable_input__6bpLi {
  position: absolute;
  inset: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
}

.LayerLatencyTable_track__RjE8F {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: var(--track-off);
  transition: background 0.2s ease;
}

.LayerLatencyTable_track__RjE8F::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--knob);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
}

.LayerLatencyTable_input__6bpLi:checked + .LayerLatencyTable_track__RjE8F {
  background: var(--track-on);
}

.LayerLatencyTable_input__6bpLi:checked + .LayerLatencyTable_track__RjE8F::after {
  transform: translateX(26px);
}

.LayerLatencyTable_input__6bpLi:focus-visible + .LayerLatencyTable_track__RjE8F {
  outline: 2px solid var(--track-on);
  outline-offset: 2px;
}

.LayerLatencyTable_state__2dGhy {
  min-width: 32px;
  font-size: 15px;
  font-weight: 700;
  color: var(--state);
}

`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/Latency/LayerLatencyCard/LayerLatencyTable.module.css"],"names":[],"mappings":"AAAA;oDACoD;;AAEpD;;2CAE2C;;AAE3C,yCAAyC;AACzC;IACI,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA,gBAAgB;AAChB;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;2CAE2C;;AAE3C;IACI,uBAAuB;IACvB,6DAA6D;AACjE;;AAEA,0DAA0D;AAC1D;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;2CAE2C;;AAE3C;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;2CAE2C;;AAE3C;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;;IAEV,iBAAiB;IACjB,yBAAyB;IACzB,6BAA6B;;IAE7B,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;2CAG2C;;AAE3C;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Layer-wise latency breakdown table + its VIN popover: extends the Device Bucketing\n   table styles (FrequencyBucketTable.module.css). */\n\n/* =========================================\n   COLUMNS\n========================================= */\n\n/* the wrapper scrolls on small screens */\ntable.table {\n    min-width: 820px;\n}\n\n/* table */\n.colLocation {\n    width: 22%;\n}\n\n.colActive {\n    width: 9%;\n}\n\n.colPct {\n    width: 9%;\n}\n\n.colBucket {\n    width: 10%;\n}\n\n.colOverall {\n    width: 11%;\n}\n\n/* VIN popover */\n.colVin {\n    width: 18%;\n}\n\n.colReg {\n    width: 12%;\n}\n\n/* =========================================\n   TWO-ROW HEADER\n========================================= */\n\n.groupHeader {\n    height: 22px !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.45) !important;\n}\n\n/* second header row sticks right below the group header */\n.subHeader {\n    top: 23px !important;\n    height: 24px !important;\n}\n\n.headerHint {\n    display: block;\n    font-size: 9px;\n    font-weight: 600;\n    opacity: 0.85;\n}\n\n/* =========================================\n   VIN STATUS (popover)\n========================================= */\n\n.activeTag {\n    display: inline-block;\n    padding: 1px 7px;\n    border-radius: 10px;\n    font-size: 10px;\n    font-weight: 600;\n}\n\n.activeOn {\n    background-color: #eafaf0;\n    color: #1aa054;\n}\n\n.activeOff {\n    background-color: #f1f3f5;\n    color: #8a97a3;\n}\n\n/* =========================================\n   NOTES (table footer, sticks to the bottom like the header)\n========================================= */\n\n.notesFoot td {\n    position: sticky;\n    bottom: 0;\n    z-index: 2;\n\n    padding: 5px 10px;\n    background-color: #f4f6f8;\n    border-top: 1px solid #dee2e6;\n\n    font-size: 10.5px;\n    color: #6b7785;\n    text-align: left;\n    white-space: normal;\n}\n\n.notesFoot span {\n    display: inline-block;\n    margin-right: 24px;\n}\n\n.notesFoot strong {\n    color: #3a4651;\n    font-weight: 600;\n}\n\n/* =========================================\n   TONES (buckets + %), city, depot and VIN rows.\n   Scoped to .table td so they beat the grey `.depotRow td` colour.\n========================================= */\n\n.table td.tone_green {\n    color: #1aa054;\n}\n\n.table td.tone_yellow {\n    color: #e6b800;\n}\n\n.table td.tone_amber {\n    color: #f59e0b;\n}\n\n.table td.tone_red {\n    color: #e5384d;\n}\n\n.table td.tone_grey {\n    color: #aeb8c1;\n    font-weight: 400;\n}\n.ignition {\n  --track-off: #dbe3f1;\n  --track-on: #5b86d6;\n  --knob: #ffffff;\n  --label: #2b3a55;\n  --state: #5b7bb5;\n\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  cursor: pointer;\n  user-select: none;\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.label {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--label);\n}\n\n.switch {\n  position: relative;\n  width: 52px;\n  height: 26px;\n  flex: none;\n}\n\n.input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  margin: 0;\n  cursor: pointer;\n}\n\n.track {\n  position: absolute;\n  inset: 0;\n  border-radius: 999px;\n  background: var(--track-off);\n  transition: background 0.2s ease;\n}\n\n.track::after {\n  content: \"\";\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--knob);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  transition: transform 0.2s ease;\n}\n\n.input:checked + .track {\n  background: var(--track-on);\n}\n\n.input:checked + .track::after {\n  transform: translateX(26px);\n}\n\n.input:focus-visible + .track {\n  outline: 2px solid var(--track-on);\n  outline-offset: 2px;\n}\n\n.state {\n  min-width: 32px;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--state);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `LayerLatencyTable_table__1Rl-g`,
	"colLocation": `LayerLatencyTable_colLocation__Cp0fF`,
	"colActive": `LayerLatencyTable_colActive__LBSMk`,
	"colPct": `LayerLatencyTable_colPct__5TL+o`,
	"colBucket": `LayerLatencyTable_colBucket__7x2gw`,
	"colOverall": `LayerLatencyTable_colOverall__pZH-X`,
	"colVin": `LayerLatencyTable_colVin__73+nc`,
	"colReg": `LayerLatencyTable_colReg__oEqNS`,
	"groupHeader": `LayerLatencyTable_groupHeader__AH0y3`,
	"subHeader": `LayerLatencyTable_subHeader__tdjN3`,
	"headerHint": `LayerLatencyTable_headerHint__f7C6p`,
	"activeTag": `LayerLatencyTable_activeTag__RjBv8`,
	"activeOn": `LayerLatencyTable_activeOn__M0Tnt`,
	"activeOff": `LayerLatencyTable_activeOff__EaMdZ`,
	"notesFoot": `LayerLatencyTable_notesFoot__jz94n`,
	"tone_green": `LayerLatencyTable_tone_green__hSHw+`,
	"tone_yellow": `LayerLatencyTable_tone_yellow__mrldN`,
	"tone_amber": `LayerLatencyTable_tone_amber__kKTmH`,
	"tone_red": `LayerLatencyTable_tone_red__NYj+b`,
	"tone_grey": `LayerLatencyTable_tone_grey__ieAQG`,
	"ignition": `LayerLatencyTable_ignition__dX0IJ`,
	"label": `LayerLatencyTable_label__43aIR`,
	"switch": `LayerLatencyTable_switch__8feyM`,
	"input": `LayerLatencyTable_input__6bpLi`,
	"track": `LayerLatencyTable_track__RjE8F`,
	"state": `LayerLatencyTable_state__2dGhy`
};
export default ___CSS_LOADER_EXPORT___;
